import { ModalCustomAttributes } from '@/components';
import { PackagesTypesProps, PriceProductProps, ProductProps } from '@/types';
import { createContext, useContext, useState, ReactNode, useCallback } from 'react';


type OpenModalProps = {
  product: ProductProps;
  pack: PackagesTypesProps;
  packQuantity: number;
  price: PriceProductProps;
}

const ModalAttributesContext = createContext<{
  openModal: (props: OpenModalProps) => void;
  closeModal: () => void;
} | undefined>(undefined);

export const ModalAttributesProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [product, setProduct] = useState<ProductProps | null>(null);
  const [packaging, setPackaging] = useState<PackagesTypesProps | null>(null);
  const [packQuantity, setPackQuantity] = useState<number>(0);
  const [price, setPrice] = useState<PriceProductProps | null>(null);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setProduct(null);
    setPackaging(null);
    setPackQuantity(0);
    setPrice(null);
  }, [setIsOpen, setProduct, setPackaging, setPackQuantity, setPrice]);

  const openModal = ({product, pack, packQuantity, price}: OpenModalProps) => {
    setProduct(product);
    setPackaging(pack);
    setPackQuantity(packQuantity);
    setPrice(price);
    setIsOpen(true);
    setIsOpen(true);
  };

  return (
    <ModalAttributesContext.Provider value={{ openModal, closeModal }}>
      {children}

      <ModalCustomAttributes
        price={price}
        isOpen={isOpen}
        pack={packaging}
        product={product}
        packQuantity={packQuantity}
        openModal={setIsOpen}
      />
    </ModalAttributesContext.Provider>
  );
};

export const useModalAttributes = () => {
  const context = useContext(ModalAttributesContext);

  if (!context) {
    throw new Error('O useModalAttributes deve ser usado dentro de um ModalAttributesProvider');
  }

  return context;
};
